module.exports = function() {
  return {
    $get: [
      function() {
        //  下载进度条
        function ProgressBar(options) {
          this.element = options.element
          this.canvasSize = options.size || options.element.clientWidth || 200 //  canvas 的宽度
          this.lineWidth = options.lineWidth || 7 // 进度条的宽度
          this.rotate = options.rotate || 0
          this.zIndex = options.zIndex || 0
          this.initCanvas()
        }

        ProgressBar.prototype.initCanvas = function() {
          const canvas = document.createElement('canvas')
          canvas.width = canvas.height = this.canvasSize
          canvas.style.position = 'absolute'
          canvas.style.top = '50%'
          canvas.style.marginTop = (-(canvas.width) / 2) + 'px'
          canvas.style.left = '50%'
          canvas.style.marginLeft = (-(canvas.height) / 2) + 'px'
          canvas.style.zIndex = this.zIndex

          this.canvasContext = canvas.getContext('2d')
          this.element.appendChild(canvas)

          this.canvasContext.translate(this.canvasSize / 2, this.canvasSize / 2)
          this.canvasContext.rotate((-1 / 2 + this.rotate / 180) * Math.PI)

          this.radius = (this.canvasSize - this.lineWidth) / 2
        }

        ProgressBar.prototype.draw = function(percent, color) {
          const context = this.canvasContext
          percent = Math.min(Math.max(0, percent || 0), 1)

          this.clearDraw()
          context.beginPath()
          context.arc(0, 0, this.radius, 0, Math.PI * 2 * percent, false)
          context.strokeStyle = color || '#03A917'
          context.lineCap = 'round' // butt, round or square
          context.lineWidth = this.lineWidth
          context.stroke()
        }

        ProgressBar.prototype.clearDraw = function() {
          const context = this.canvasContext
          const canvasSize = this.canvasSize
          context.clearRect(-(canvasSize / 2), -(canvasSize / 2), canvasSize, canvasSize)
        }

        const progressbar = {
          init: function(options) {
            return new ProgressBar(options)
          }
        }

        return progressbar
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/js/infrastructure/utils/progressbar.js